<div class="footer-mainwrapper">
    <div class="new-container">
        <p>Copyright © 2000-{{footerYear}} Divine Infinite Being. All rights reserved.</p>
    </div>
</div>
